import axios from 'axios'

export const HOST = '/api/3'
export const HOST_TULUM = '/tulum'

export const imProcApi = axios.create({
  baseURL: '/im_process/'
})

export const planetSearchApi = axios.create({
  baseURL: '/planet_search/'
})


// API V3
export const API = axios.create({})

// Flag to prevent multiple simultaneous refresh attempts
let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })

  failedQueue = []
}

function getLocalAccessToken() {
  return localStorage.getItem('accessToken')
}

function getLocalRefreshToken() {
  return window.localStorage.getItem('refreshToken')
}

function refreshToken() {
  return API.post(`${HOST}/token/refresh/`, {
    refresh_token: getLocalRefreshToken(),
  })
}

function clearTokens() {
  window.localStorage.removeItem('accessToken')
  window.localStorage.removeItem('refreshToken')
}

API.interceptors.request.use(
  async config => {
    const token = getLocalAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config;
  },
  error => Promise.reject(error)
)

API.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config

    // Don't intercept refresh token requests to avoid infinite loops
    if (originalRequest.url?.includes('/token/refresh/')) {
      return Promise.reject(error)
    }

    // Initialize retry count if it doesn't exist
    if (!originalRequest._retryCount) {
      originalRequest._retryCount = 0
    }

    if (error.response?.status === 401 && originalRequest._retryCount < 3) {
      if (isRefreshing) {
        // If already refreshing, queue this request
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject })
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`
          return API(originalRequest)
        }).catch(err => {
          return Promise.reject(err)
        })
      }

      originalRequest._retryCount += 1
      isRefreshing = true

      try {
        const rs = await refreshToken()
        const { access_token } = rs.data
        window.localStorage.setItem('accessToken', access_token)
        originalRequest.headers.Authorization = `Bearer ${access_token}`

        processQueue(null, access_token)
        isRefreshing = false

        return API(originalRequest)
      } catch (_error) {
        processQueue(_error, null)
        isRefreshing = false

        // If refresh failed, clear tokens
        clearTokens()

        if (_error.response && _error.response.data) {
          return Promise.reject(_error.response.data)
        }

        return Promise.reject(_error)
      }
    }

    return Promise.reject(error)
  }
)
